import React from 'react';
import { ToolResultProps } from '../types';
import { Search, CheckCircle2, AlertCircle, List } from "lucide-react";

const FindTextResult: React.FC<ToolResultProps> = ({ thought }) => {
    const { success, toolResult } = thought;

    // Extraer datos del toolResult o del contenido
    let data: any = toolResult?.metadata || {};

    if (!data.query && thought.content) {
        try {
            // Si el contenido ya es un objeto (porque algún procesador lo parseó)
            if (typeof thought.content === 'object') {
                data = thought.content;
            } else if (typeof thought.content === 'string' && thought.content.trim().startsWith('{')) {
                data = JSON.parse(thought.content);
            }
        } catch (e) {
            console.error('Error parsing find_text content:', e);
        }
    }

    const query = data.query || '';
    const totalCount = data.total_count !== undefined ? data.total_count : 0;
    const occurrences = data.occurrences || [];

    const isSuccess = success !== false;

    return (
        <div className="mt-1.5 px-1 py-1 flex flex-col gap-2">
            <div className="flex items-center gap-2">
                <div className={`p-1 rounded-sm ${isSuccess ? 'bg-blue-50 text-blue-500' : 'bg-red-50 text-red-500'}`}>
                    <Search className="h-3.5 w-3.5" />
                </div>

                <div className="flex flex-col">
                    <div className="flex items-center gap-1.5">
                        <span className={`text-[11px] font-medium ${isSuccess ? 'text-foreground/80' : 'text-red-600'}`}>
                            Find text: <span className="font-bold">"{query}"</span>
                        </span>
                        {isSuccess ? (
                            <CheckCircle2 className="h-2.5 w-2.5 text-emerald-500/60" />
                        ) : (
                            <AlertCircle className="h-2.5 w-2.5 text-red-500/60" />
                        )}
                    </div>
                    <span className="text-[10px] text-muted-foreground italic">
                        {isSuccess
                            ? (totalCount > 0 ? `Found ${totalCount} occurrence${totalCount === 1 ? '' : 's'}` : 'No matches found')
                            : 'Search failed'}
                    </span>
                </div>
            </div>

            {isSuccess && occurrences.length > 0 && (
                <div className="ml-7 border-l border-muted pl-3 flex flex-col gap-1.5">
                    {occurrences.slice(0, 5).map((occ: any, idx: number) => (
                        <div key={idx} className="flex flex-col gap-0.5">
                            <div className="flex items-center gap-1.5 text-[9px] text-muted-foreground">
                                <List className="h-2.5 w-2.5" />
                                <span>
                                    {occ.location || `Paragraph ${occ.paragraph_index}`}
                                </span>
                            </div>
                            <div className="text-[10px] text-foreground/70 bg-muted/30 px-1.5 py-1 rounded-sm border border-muted/20 italic">
                                "{occ.context}"
                            </div>
                        </div>
                    ))}
                    {occurrences.length > 5 && (
                        <span className="text-[9px] text-muted-foreground italic mt-0.5">
                            ... and {occurrences.length - 5} more
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default FindTextResult;
